module.exports = {"IS_SUPER_USER":"is_superuser","IS_ADMIN":"admin","PERMISSION":{"PK":"pk","NAME":"name","SLUG":"slug","NAMESPACE_PATH":"namespace_path","IS_VISIBLE_FOR_STAFF":"is_visible_for_staff"}}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/integrationMaps/permissions.json
// module id = 638
// module chunks = 1